import guest from "@/middleware/guest";

export default [
    {
        path: "termos_tricard",
        name: "termos_tricard",
        meta: { middleware: [guest] },
        component: () => import("./TermosTricard")
    }
];
